// EMERGENCY POLYFILL - Must be FIRST before any imports
// Fix for: Cannot destructure property 'Request' of 'undefined' in production
if (typeof globalThis.Request === 'undefined') {
  const noop = function() {};
  const noopFetch = function() { return Promise.resolve({ ok: false }); };

  globalThis.Request = noop as any;
  globalThis.Response = noop as any;
  globalThis.Headers = noop as any;
  globalThis.fetch = noopFetch as any;

  // Also set on window for compatibility
  (window as any).Request = globalThis.Request;
  (window as any).Response = globalThis.Response;
  (window as any).Headers = globalThis.Headers;
  (window as any).fetch = globalThis.fetch;

  // Ensure global object exists and has fetch APIs
  if (typeof (window as any).global === 'undefined') {
    (window as any).global = window;
  }
  (window as any).global.Request = globalThis.Request;
  (window as any).global.Response = globalThis.Response;
  (window as any).global.Headers = globalThis.Headers;
  (window as any).global.fetch = globalThis.fetch;
}

import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { Provider } from 'react-redux';
import { store } from './redux/store.ts';
import { captureUtmsFromUrl, captureClickIdsFromUrl } from './shared/attribution/utm-manager';
import { captureReferralFromUrl } from './shared/attribution/referral';
import { captureAffiliateClickFromUrl } from './shared/attribution/affiliate';
import { capturePlatformFromUrl } from './shared/utils/general.util';
import { captureCheckoutIntentFromUrl } from './shared/checkout/checkoutIntent';
import {
	captureEntryIntentFromUrl,
	capturePartnerFromUrl,
} from './features/onboarding/lib/onboardingTargets';
import { captureCertificatesDeeplinkFromUrl } from './shared/deeplinks/certificatesDeeplink';
import { emitTouchpoint, stitchSession } from './shared/services/acquisition.service';
import { captureMaintenanceBypassFromUrl } from './features/maintenance/lib/maintenanceBypass';
import './index.css'

// Capture deeplink params from the URL BEFORE React mounts. Doing it here
// (not in a hook) means the values are set before first render and survive
// every router redirect, including the bounce through /login for anonymous
// landings — they're replayed once the user authenticates.
captureUtmsFromUrl();          // ?utm_* (attribution, overwrite policy)
captureClickIdsFromUrl();      // ?gclid / ?fbclid / ?ttclid … (ad click IDs)
captureReferralFromUrl();      // ?referral_code / ?campaign_id
captureAffiliateClickFromUrl(); // ?sub1 / ?sub2 (clic de afiliado — factura)
capturePlatformFromUrl();      // ?platform_os / ?viewed_from
captureCheckoutIntentFromUrl(); // ?add_to_cart / ?coupon / ?year_<pv> / ?asat_<pv>
capturePartnerFromUrl();       // ?partner=<aliado> (campañas de aliados)
captureEntryIntentFromUrl();   // ?intent=facturar (its own slot, never the ally target)
captureCertificatesDeeplinkFromUrl(); // /certificates/?src=&c= (campaña a Rappitenderos, t-152)
captureMaintenanceBypassFromUrl(); // ?mantenimiento=off|on (bypass de QA por pestaña)

// Emit one acquisition touchpoint per session (NOT per route). Fire-and-forget.
try {
  const SESSION_TOUCHPOINT_KEY = 'heru_touchpoint_session_start';
  if (!sessionStorage.getItem(SESSION_TOUCHPOINT_KEY)) {
    sessionStorage.setItem(SESSION_TOUCHPOINT_KEY, '1');
    emitTouchpoint({ touch_type: 'session_start' });
  }
} catch {
  // sessionStorage unavailable — skip the session guard, don't block boot.
}

// If already authenticated, re-stitch this browser's anonymous touches to the
// user once per session (catches post-signup / returning-user / out-of-order
// touches the signup-time stitch missed). Self-guards on token + session.
stitchSession();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
      <App />
  </Provider>
)

// Register PWA service worker (non-blocking)
import('./pwa');
